var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel panel-default panel-block panel-title-block",attrs:{"id":"top"}},[_c('div',{staticClass:"panel-heading"},[_c('div',[_c('i',{class:_vm.ui.icon}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.ui.title)),_c('span',{staticClass:"page-title"}),_c('small',[_vm._v(_vm._s(_vm.ui.subtext))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }